import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserTypeToggle } from "./UserTypeToggle";
import { WaitlistForm } from "./WaitlistForm";
import { HeroContent } from "./hero/HeroContent";
import { HeroActions } from "./hero/HeroActions";

interface HeroProps {
  onUserTypeChange?: (isPro: boolean) => void;
  defaultIsPro?: boolean;
}

export const Hero = ({ onUserTypeChange, defaultIsPro }: HeroProps) => {
  const [isPro, setIsPro] = useState(defaultIsPro ?? true);
  const [showWaitlist, setShowWaitlist] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (defaultIsPro !== undefined) {
      setIsPro(defaultIsPro);
      onUserTypeChange?.(defaultIsPro);
    }
  }, [defaultIsPro, onUserTypeChange]);

  const handleToggle = (newIsPro: boolean) => {
    setIsPro(newIsPro);
    onUserTypeChange?.(newIsPro);
    navigate(newIsPro ? '/pro' : '/particulier');
    
    document.title = newIsPro 
      ? "NLocale • Plateforme de réservation pour pros de l'Aisne | Hébergements, Restaurants, Événements"
      : "NLocale • Découvrez l'Aisne comme un local : Réservations de gîtes, restos & activités";
    
    document.querySelector('meta[name="description"]')?.setAttribute(
      "content",
      newIsPro 
        ? "Réservez hébergements, restaurants et événements dans l'Aisne avec NLocale. Pour les pros locaux et les visiteurs en quête d'authenticité. 🧀 #AisneSecret"
        : "Explorez l'Aisne avec NLocale : réservez gîtes, restos et événements locaux. Parce que l'Aisne, c'est plus que des champs. 🌾"
    );
  };

  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-4 pb-8 w-full overflow-x-hidden">
      <div className="w-full max-w-full">
        <UserTypeToggle onToggle={handleToggle} defaultIsPro={defaultIsPro} />
      </div>
      
      <div className="max-w-4xl mx-auto mt-12 text-center animate-fadeIn px-4 w-full">
        <HeroContent isPro={isPro} onShowWaitlist={() => setShowWaitlist(true)} />
        <HeroActions isPro={isPro} onShowWaitlist={() => setShowWaitlist(true)} />
      </div>

      <WaitlistForm
        isPro={isPro}
        open={showWaitlist}
        onOpenChange={setShowWaitlist}
      />
    </section>
  );
};